import { Injectable } from "@angular/core";
import { CurrentMdInfo } from "app/models";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BaseService } from "./base.service";

@Injectable()
export class StateService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getCurrentMatchDay(): Observable<any> {
        return this.httpService.get<any>(this.apiUrl + 'state/md', null);
    }
}